<script>
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import { Helper } from '@/mixin/helper'
import {
  GET_PART_BRANDS,
  GET_PART_BRAND_BY_ID,
  CREATE_PART_BRAND,
  UPDATE_PART_BRAND,
  DELETE_PART_BRAND,
} from '@/services/api/setting/maintenance/parts/brand'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },

  computed: {
    fields() {
      return [
        {
          key: 'brand',
          label: this.$t('setting.list.maintenance.brand'),
          placeholder: this.$t('setting.list.maintenance.brand'),
          thClass: 'mc-table--50',
          isSortable: false,
          editable: true,
          validation: [['required', 'trim']],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_PART_BRANDS,
            variables: {
              filter: filter,
            },
          })

          return res.data.partBrands.partBrands
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: CREATE_PART_BRAND,
            variables: {
              input: data,
            },
          })

          if (!res.data.createPartBrand.isSuccessful) {
            if (res.data.createPartBrand.errorName === 'PartBrandAlreadyExist')
              this.$mcToast.error(
                this.$t('setting.list.maintenance.alert.' + res.data.createPartBrand.errorName)
              )
            return false
          } else {
            const newData = await this.$apollo.query({
              fetchPolicy: 'no-cache',
              query: GET_PART_BRAND_BY_ID,
              variables: {
                filter: {
                  partBrandId: res.data.createPartBrand.createPartBrand.partBrandId,
                },
              },
            })

            return newData.data.partBrand.partBrand
          }
        },
        update: async (id, oldData, newData) => {
          const input = {
            partBrandId: id,
            oldData: {
              brand: oldData.brand,
            },
            newData: {
              brand: newData.brand,
            },
          }

          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: UPDATE_PART_BRAND,
            variables: {
              input: input,
            },
          })

          if (!res.data.updatePartBrand.isSuccessful) {
            if (res.data.updatePartBrand.errorName === 'PartBrandAlreadyExist')
              this.$mcToast.error(
                this.$t('setting.list.maintenance.alert.' + res.data.updatePartBrand.errorName)
              )
            else {
              this.$mcToast.error({
                component: 'McToastDynamicBody',
                props: {
                  contents: [
                    {
                      tag: 'h6',
                      text: this.$t('maintenance.alert.editFailed'),
                    },
                    {
                      tag: 'p',
                      text: this.$t(`global.alert.text.failedEdit`),
                    },
                  ],
                },
              })
            }
            return false
          }

          if (!res.data.updatePartBrand.updatePartBrand) return true
          return res.data.updatePartBrand.updatePartBrand
        },
        delete: async (id) => {
          const input = {
            partBrandId: +id,
          }

          const res = await this.$apollo.mutate({
            fetchPolicy: 'no-cache',
            mutation: DELETE_PART_BRAND,
            variables: {
              input: input,
            },
          })

          return res.data.deletePartBrand.isSuccessful
        },
      }
    },
  },

  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },

  methods: {
    handleClick() {
      this.$router.push({ name: 'Log Maintenance Setting', params: { type: 'category' } })
    },
    customToast() {
      this.$mcToast.error({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              tag: 'h6',
              text: this.$t('maintenance.alert.deleteFailed'),
            },
            {
              tag: 'p',
              text: this.$t(`setting.list.maintenance.alert.ResourceBeingUsedInMaster`),
            },
          ],
        },
      })
    },
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0 pb-4" @click="$store.commit('setting/SET_STATUS', status)">
    <template v-slot:title>
      <span class="d-sm-inline-block">{{ $t('setting.list.maintenance.brand') }}</span>
    </template>

    <!-- Table -->
    <McGraphqlEditableTable
      :fields="fields"
      :apiClient="query"
      trackBy="partBrandId"
      :searchable="true"
      :customToast="customToast"
    />
  </b-tab>
</template>
